import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Link } from 'react-router-dom';
import { BACKEND_URL, ImageURL } from "../common/Common";
import useEmirateFromCoordinates from "../common/Common";
import axios from "axios";
import Slider from "react-slick";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import "../categorylist/CategoryList.css"
//Navbar and Left Section Images
import hayatin from '../../assets/images/hayatin.jpg';
import homeicon from '../../assets/home-images/homeicon.jpg';
import experienceicon from '../../assets/home-images/experienceicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
import plusicon from '../../assets/home-images/plusicon.png';
import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
import videos from '../../assets/home-images/videos.png';
import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
import menu from '../../assets/home-images/menu.png';
import downarrow from '../../assets/home-images/downarrow.png';
import leftarrow from '../../assets/offers/leftarrow.png';
import flagicon from '../../assets/home-images/flagicon.png';

import expbanner from '../../assets/experience/Expbanner.png';


import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import downarrowicon from '../../assets/categorylist/downarrowicon.png';
import filtericon from '../../assets/categorylist/filtericon.png';
import mapicon from '../../assets/categorylist/mapicon.png';
import menuicon from '../../assets/categorylist/menuicon.png';
import vertical_line from '../../assets/categorylist/vertical_line.png';



import omanflag from '../../assets/experience/omanflag.png';
import qatarflag from '../../assets/experience/qatarflag.png';
import kuwaitflag from '../../assets/experience/kuwaitflag.png';
import ksaflag from '../../assets/experience/ksaflag.png';
import businessicon1 from '../../assets/experience/businessicon1.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import nodata from '../../assets/experience/nodata.png';
import Navbar from "../common-component/navbar/Navbar";



const countryicons = [omanflag, qatarflag, kuwaitflag, ksaflag]

const CategoryList = () => {
    const { parentId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    // const { id } = useParams();
    const sliderRef = useRef(null);
    const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [latitude, setLatitude] = useState(24.4539);
    const [longitude, setLongitude] = useState(54.3773);
    const [categories, setCategories] = useState([]);
    const emirate = useEmirateFromCoordinates(latitude, longitude);

    // Get state_id from URL query params
    const urlStateId = searchParams.get('state_id');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [filtepopup, setFilterpopup] = useState(false);
    const [subcategories, setSubcategories] = useState([]);
    const [getattributes, setGetattributes] = useState([]);
    const [showSubcategories, setShowSubcategories] = useState(false);
    const [openAttributeId, setOpenAttributeId] = useState(null);
    const [offertype, setOffertype] = useState([]);
    const [openoffertype, setOpenoffertype] = useState(false);
    const [categorylist, setCategorylist] = useState([]); // categorylist Post api state 
    const [selectedCategory, setSelectedCategory] = useState(parentId);
    const [categoryName, setCategoryName] = useState("");
    const [selectedOfferTypes, setSelectedOfferTypes] = useState([]);
    const [selectedSubcategories, setSelectedSubcategories] = useState([]);
    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [filteredCategoryList, setFilteredCategoryList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isCategoryListLoading, setIsCategoryListLoading] = useState(!!parentId);
    const [searchTerm, setSearchTerm] = useState("");

    // Scroll to top on mount (fixes mobile scroll position issue)
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);


    const toggleAttributeFields = useCallback((attributeId) => {
        setOpenAttributeId(prev => prev === attributeId ? null : attributeId);
    }, []);

    const toggleSubcategories = useCallback(() => {
        setShowSubcategories(prev => !prev);
    }, []);

    const toggleOfffertype = useCallback(() => {
        setOpenoffertype(prev => !prev);
    }, []);


    const handleSubcategoryChange = useCallback((e, id) => {
        const numericId = Number(id);
        if (e.target.checked) {
            setSelectedSubcategories(prev => [...prev, numericId]);
        } else {
            setSelectedSubcategories(prev => prev.filter((item) => item !== numericId));
        }
    }, []);

    const handleOfferTypeChange = useCallback((e, id) => {
        if (e.target.checked) {
            setSelectedOfferTypes(prev => [...prev, Number(id)]);
        } else {
            setSelectedOfferTypes(prev => prev.filter((item) => item !== Number(id)));
        }
    }, []);

    const handleAttributeChange = useCallback((e, id) => {
        if (e.target.checked) {
            setSelectedAttributes(prev => [...prev, id]);
        } else {
            setSelectedAttributes(prev => prev.filter((item) => item !== id));
        }
    }, []);

    const handleSearchChange = useCallback((e) => {
        setSearchTerm(e.target.value);
    }, []);


    const clearAllFilters = useCallback(() => {
        setSelectedSubcategories([]);
        setSelectedOfferTypes([]);
        setSelectedAttributes([]);
        setFilteredCategoryList([]);
    }, []);

    const handleShowResult = useCallback(async () => {
        // If no filters selected, clear the filter and reload default list
        if (selectedSubcategories.length === 0 &&
            selectedOfferTypes.length === 0 &&
            selectedAttributes.length === 0) {
            setFilteredCategoryList([]);
            setFilterpopup(false);
            // Reload default category list
            if (selectedCategory) {
                setIsCategoryListLoading(true);
                try {
                    await fetchCategorylist(selectedCategory, searchTerm.trim(), []);
                    setFilteredCategoryList([]);
                } catch (error) {
                    console.error("Error fetching default category list:", error);
                } finally {
                    setIsCategoryListLoading(false);
                }
            }
            return;
        }

        // If subcategories are selected, call API with subcategory_id
        if (selectedSubcategories.length > 0 && selectedCategory) {
            setFilterpopup(false);
            setIsCategoryListLoading(true);
            try {
                await fetchCategorylist(selectedCategory, searchTerm.trim(), selectedSubcategories);
                setFilteredCategoryList([]); // Clear filtered list to show API results directly
            } catch (error) {
                console.error("Error fetching filtered category list:", error);
            } finally {
                setIsCategoryListLoading(false);
            }
        } else {
            // If only offer types or attributes selected (no subcategories), filter client-side
            if (!Array.isArray(categorylist) || categorylist.length === 0) {
                setFilteredCategoryList([]);
                setFilterpopup(false);
                return;
            }

            const result = categorylist.filter(item => {
                // Check offer type
                let offerTypeMatch = true;
                if (selectedOfferTypes.length > 0) {
                    offerTypeMatch = selectedOfferTypes.includes(item.discount_type_id);
                }

                // Check attributes (if needed)
                let attributeMatch = true;
                if (selectedAttributes.length > 0) {
                    // Add attribute matching logic here if needed
                }

                return offerTypeMatch && attributeMatch;
            });

            setFilteredCategoryList(result);
            setFilterpopup(false);
        }
    }, [selectedSubcategories, selectedOfferTypes, selectedAttributes, categorylist, selectedCategory, searchTerm]);
    const getDisplayCategoryList = useMemo(() => {
        // If filteredCategoryList has items (client-side filtering), use it
        if (filteredCategoryList.length > 0) {
            return Array.isArray(filteredCategoryList) ? filteredCategoryList : [];
        }
        // Otherwise, use categorylist (which contains API results, filtered or unfiltered)
        return Array.isArray(categorylist) ? categorylist : [];
    }, [filteredCategoryList, categorylist]);


    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/categories`);
            // Handle different possible response structures
            let categoriesData = [];
            if (response.data) {
                if (Array.isArray(response.data)) {
                    categoriesData = response.data;
                } else if (response.data.data && Array.isArray(response.data.data)) {
                    categoriesData = response.data.data;
                } else if (response.data.categories && Array.isArray(response.data.categories)) {
                    categoriesData = response.data.categories;
                }
            }
            setCategories(categoriesData);
            console.log("All Categories:", categoriesData);

        } catch (error) {
            console.error("Error fetching categories:", error);
            setCategories([]); // Ensure it's always an array
        }
    };
    const fetchMasterData = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-master-data`);
            if (response.data.stateData) {
                setStates(response.data.stateData);
            } else {
                setStates([]);
            }
        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };



    const fetchGetattributes = async () => {
        try {
            if (!selectedCategory) {
                setGetattributes([]);
                return;
            }
            const response = await axios.post(`${BACKEND_URL}website/get-attributes`, {
                category_id: selectedCategory
            });
            const data = response.data || [];
            setGetattributes(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error fetching attributes:", error);
            setGetattributes([]); // fallback
        }
    };


    const fetchOffertype = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-common-data`);
            setOffertype(response.data || {});
        } catch (error) {
            console.error("Error fetching offer types:", error);
            setOffertype({}); // Ensure it's always an object
        }
    }


    const fetchCategorylist = async (selectedCategory, search = "", subcategoryIds = []) => {
        try {
            if (!selectedCategory) {
                setCategorylist([]);
                setCategoryName("");
                return [];
            }

            // Ensure subcategoryIds is an array of numbers (remove duplicates and invalid values)
            const subcategoryIdArray = Array.isArray(subcategoryIds)
                ? [...new Set(subcategoryIds.map(id => Number(id)).filter(id => !isNaN(id) && id > 0))]
                : [];

            // Use state_id from URL if available (highest priority), otherwise use selectedState or emirate
            const stateId = urlStateId ? Number(urlStateId) : (selectedState?.id || emirate?.id || 1);

            console.log("📡 Fetching category list:", {
                urlStateId: urlStateId,
                selectedStateId: selectedState?.id,
                emirateId: emirate?.id,
                finalStateId: stateId,
                categoryId: selectedCategory
            });

            const payload = {
                state_id: stateId,
                latitude: latitude,
                longitude: longitude,
                category_id: Number(selectedCategory),
                search: search || "",
            };

            // Only include subcategory_id if there are selected subcategories
            // Backend expects subcategory_id as a JSON string, not an array
            if (subcategoryIdArray.length > 0) {
                payload.subcategory_id = JSON.stringify(subcategoryIdArray);
            }

            console.log('API Payload:', JSON.stringify(payload, null, 2));

            const response = await axios.post(`${BACKEND_URL}website/get-coupon-list`, payload);

            const data = response.data?.data || response.data || [];
            const categoryListData = Array.isArray(data) ? data : [];
            setCategorylist(categoryListData);

            // Get category_name once from the first coupon that matches
            if (categoryListData.length > 0) {
                for (let item of categoryListData) {
                    if (item.category && Array.isArray(item.category)) {
                        const cat = item.category.find(c => c && c.category === Number(selectedCategory));
                        if (cat && cat.category_name) {
                            setCategoryName(cat.category_name);
                            break;
                        }
                    }
                }
            } else {
                // If no data, get category name from categories array
                const selectedCat = categories.find(cat => cat.id === Number(selectedCategory));
                if (selectedCat && selectedCat.category_name) {
                    setCategoryName(selectedCat.category_name);
                }
                // Don't set to empty - let useEffect handle it from categories array
                // This prevents clearing the name if categories haven't loaded yet
            }

            return categoryListData;

        } catch (error) {
            console.error("Error fetching categories list:", error);
            console.error("Error details:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            setCategorylist([]);
            // Try to get category name from categories array as fallback (if categories is loaded)
            if (Array.isArray(categories) && categories.length > 0 && selectedCategory) {
                const selectedCat = categories.find(cat => cat.id === Number(selectedCategory));
                if (selectedCat && selectedCat.category_name) {
                    setCategoryName(selectedCat.category_name);
                }
            }
            // Don't set to empty - let useEffect handle it from categories array
            // This prevents clearing the name if categories haven't loaded yet
            return [];
        }
    };


    // Load selected state from URL query params or localStorage on mount
    useEffect(() => {
        // First check if state_id is in URL
        if (urlStateId && states.length > 0) {
            const stateFromUrl = states.find(state => state.id.toString() === urlStateId.toString());
            if (stateFromUrl) {
                console.log("🟢 Loading state from URL:", stateFromUrl.name, "ID:", stateFromUrl.id);
                setSelectedState(stateFromUrl);
                const lat = parseFloat(stateFromUrl.latitude || stateFromUrl.lat || 24.4539);
                const lng = parseFloat(stateFromUrl.longitude || stateFromUrl.lng || 54.3773);
                setLatitude(lat);
                setLongitude(lng);
                // Save to localStorage
                localStorage.setItem('selectedState', JSON.stringify(stateFromUrl));
                return;
            } else {
                console.warn("⚠️ State ID from URL not found in states array:", urlStateId);
            }
        }

        // Fallback to localStorage only if no URL state_id
        if (!urlStateId) {
            const savedState = localStorage.getItem('selectedState');
            if (savedState) {
                try {
                    const parsedState = JSON.parse(savedState);
                    setSelectedState(parsedState);
                    const lat = parseFloat(parsedState.latitude || parsedState.lat || 24.4539);
                    const lng = parseFloat(parsedState.longitude || parsedState.lng || 54.3773);
                    setLatitude(lat);
                    setLongitude(lng);
                } catch (error) {
                    console.error("Error parsing saved state:", error);
                }
            }
        }
    }, [urlStateId, states]);

    useEffect(() => {
        // Only use geolocation if no saved state exists
        if (!localStorage.getItem('selectedState') && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        }
    }, []);

    // Handle location change from country popup
    const handleStateChange = (state) => {
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        console.log("🟢 Location Selected:", state.name, "Lat:", lat, "Lng:", lng);

        setSelectedState(state);
        setLatitude(lat);
        setLongitude(lng);
        setCountrypopup(false);

        localStorage.setItem('selectedState', JSON.stringify(state));
    };

    const discoverdata = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1 },
            },
        ],
    }


    // Batch initial API calls for better performance
    useEffect(() => {
        const fetchInitialData = async () => {
            setIsLoading(true);
            try {
                // Run all initial API calls in parallel
                await Promise.all([
                    fetchMasterData(),
                    fetchCategories(),
                    fetchOffertype()
                ]);
            } catch (error) {
                console.error("Error fetching initial data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchInitialData();
    }, []);

    // Batch category-specific API calls
    useEffect(() => {
        if (!selectedCategory) {
            setIsCategoryListLoading(false);
            return;
        }

        // If URL has state_id, wait for states to load before fetching
        if (urlStateId && states.length === 0) {
            console.log("⏳ Waiting for states to load before fetching category data...");
            return;
        }

        const fetchCategoryData = async () => {
            setIsCategoryListLoading(true);
            try {
                // Run category-specific calls in parallel
                await Promise.all([
                    fetchGetattributes(),
                    fetchCategorylist(selectedCategory, searchTerm.trim())
                ]);
            } catch (error) {
                console.error("Error fetching category data:", error);
            } finally {
                setIsCategoryListLoading(false);
            }
        };
        fetchCategoryData();
    }, [selectedCategory, latitude, longitude, emirate, selectedState, urlStateId, states]);

    // Scroll carousel to selected category
    useEffect(() => {
        if (selectedCategory && categories.length > 0 && sliderRef.current) {
            const categoryIndex = categories.findIndex(cat => cat.id === Number(selectedCategory));
            if (categoryIndex !== -1 && sliderRef.current.slickGoTo) {
                // Use setTimeout to ensure slider is fully initialized
                setTimeout(() => {
                    sliderRef.current.slickGoTo(categoryIndex);
                }, 100);
            }
        }
    }, [selectedCategory, categories]);

    // Debounced search effect - only triggers when searchTerm changes
    useEffect(() => {
        if (!selectedCategory) {
            return;
        }

        // Clear filtered list when searching or clearing search
        setFilteredCategoryList([]);

        // Debounce the API call
        const timeoutId = setTimeout(() => {
            setIsCategoryListLoading(true);
            fetchCategorylist(selectedCategory, searchTerm.trim())
                .then(() => {
                    setIsCategoryListLoading(false);
                })
                .catch((error) => {
                    console.error("Error fetching category list with search:", error);
                    setIsCategoryListLoading(false);
                });
        }, 500); // 500ms debounce delay

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);

    // Sync categoryName from categories array when categories load or selectedCategory changes
    // This ensures category name displays even when API returns empty data or on refresh
    useEffect(() => {
        if (selectedCategory && categories.length > 0) {
            const selectedCat = categories.find(cat => cat.id === Number(selectedCategory));
            if (selectedCat && selectedCat.category_name) {
                // Always update from categories array to ensure it persists on refresh
                // This takes priority over API response name
                setCategoryName(selectedCat.category_name);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCategory, categories]);

    // Extract subcategories from selected category and set to state
    useEffect(() => {
        if (selectedCategory && categories.length > 0) {
            const selectedCat = categories.find(cat => cat.id === Number(selectedCategory));
            if (selectedCat && Array.isArray(selectedCat.subcategories)) {
                setSubcategories(selectedCat.subcategories);
                console.log("Selected Category:", selectedCat.category_name);
                console.log("Subcategories for", selectedCat.category_name, ":", selectedCat.subcategories);
            } else {
                setSubcategories([]);
                console.log("Selected Category:", selectedCat?.category_name, "- No subcategories found");
            }
            // Clear selected subcategories when category changes
            setSelectedSubcategories([]);
            setFilteredCategoryList([]);
        } else {
            setSubcategories([]);
            setSelectedSubcategories([]);
        }
    }, [selectedCategory, categories]);





    return (
        <div>
            <Navbar />

            {/* Mobile Header - Below Navbar */}
            <div className="mobile-category-header">
                <div className="mobile-header-top">
                    <div className="mobile-category-title">
                        <img src={leftarrow} alt="back" className="mobile-back-icon" onClick={() => navigate(-1)} />
                        {categoryName ? (
                            <h4><span>Experience /</span> {categoryName}</h4>
                        ) : (
                            <h4></h4>
                        )}
                    </div>
                    {/* <div className="mobile-location-dropdown" onClick={() => setCountrypopup(true)}>
                        <img src={flagicon} alt="flag" className="mobile-flag-icon" />
                        <span>Abu Dhabi</span>
                        <img src={downarrowicon} alt="dropdown" className="mobile-dropdown-icon" />
                    </div> */}
                </div>
                <div className="mobile-search-filter-container">
                    <div className="mobile-searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search offers..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <img
                        src={filtericon}
                        alt="filter"
                        className="mobile-filter-icon"
                        onClick={() => setFilterpopup(true)}
                    />
                </div>
            </div>

            <div className="experience-main-layout  category-list-page-main-layout">
                <aside className="left-section">
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="left-menu-content">
                        {/* <div className="img-contentname">
                            <img src={videos} alt="videos" />
                            <p>Videos for you</p>
                        </div> */}
                        {/* <div className="img-contentname">
                            <img src={blogs} alt="blogs" />
                            <p>Blogs</p>
                        </div>
                        <div className="img-contentname">
                            <img src={save} alt="save" />
                            <p>Saved</p>
                        </div>
                        <div className="img-contentname">
                            <img src={profileicon} alt="profileicon" />
                            <p>Profile</p>
                        </div>
                        <div className="img-contentname">
                            <img src={plusicon} alt="plusicon" />
                            <p>Post</p>
                        </div>
                        <div className="img-contentname">
                            <img src={menu} alt="menu" />
                            <p>Menu</p>
                        </div> */}
                        <div className="img-contentname" onClick={() => setCountrypopup(true)} >
                            <img src={flagicon} alt="flag" className="flagicon" />
                            <p>{selectedState?.name || emirate?.name || "Abu Dhabi"}</p>
                        </div>
                    </div>
                    <div className="divider-line"></div>
                    {/* <div className="left-bottom-links">
                        <div className="left-bottom1">
                            <a href="/about">About</a>
                            <a href="#BusinessPro">Business Pro</a>
                        </div>
                        <div className="left-bottom1">
                            <a href="#help-center">Help Center</a>
                            <a href="#FAQ">FAQ</a>
                            <a href="#Careers">Careers</a>
                        </div>
                        <div className="left-bottom1">
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                            <div className="content-arrow">
                                <a href="#Languages">Language</a>
                                <img src={downarrow} alt="downarrow" />
                            </div>
                        </div>
                    </div> */}
                    <div className="left-bottom-links">
                        <div className="left-bottom1">
                            <a href="/about">About Us</a>
                            {/* <a href="#BusinessPro">Business Pro</a> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                              <a href="/businesspro">Business Pro</a>
                            <a href="/downloadpage">Download</a>
                        </div>

                        {/* Uncomment these sections when you need them */}
                        {/* 
                                    <div className="left-bottom1">
                                        <a href="#help-center">Help Center</a>
                                        <a href="#FAQ">FAQ</a>
                                        <a href="#Careers">Careers</a>
                                    </div>
                                    <div className="left-bottom1">
                                        <div className="content-arrow">
                                            <Link to="/merchantagreement" className="privacy-link">
                                                <span>Privacy & Terms</span>
                                                <img src={downarrow} alt="down arrow" />
                                            </Link>
                                        </div>
                                        <div className="content-arrow">
                                            <a href="#Languages">Language</a>
                                            <img src={downarrow} alt="downarrow" />
                                        </div>
                                    </div>
                                    */}
                    </div>
                </aside>

                <main className="experience-middle-section">
                    <div className="mid-section-head-div">
                        <img src={expbanner} alt="enjoy summer" className="enjoy-summer-img" />
                    </div>


                    <div className="categorylist-wrapper">
                        <div className="categorylist-section">
                            {Array.isArray(categories) && categories.length > 0 ? (
                                <Slider ref={sliderRef} {...discoverdata}>
                                    {categories.map((item, index) => (
                                        <div className="discover-carousel-card" onClick={() => setSelectedCategory(item.id)} key={index}>
                                            <div className="categorylist-card-inner">
                                                <img
                                                    src={item.image}
                                                    alt={item.category_name}
                                                    className={item.id === Number(selectedCategory) ? "selected" : ""}
                                                />
                                                <p>{item.category_name}</p>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            ) : (
                                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                                    Loading categories...
                                </div>
                            )}
                        </div>

                        <div className="category-list-menu-filter-div">
                            <img src={rightarrow} alt="down arrow icon" className="right-arrow-icon" onClick={() => setIsPopupOpen(true)} />
                            <div className="menu-map-filter-div">
                                <img src={menuicon} alt="menu icon" className="menu-icon" />
                                {/* <img src={mapicon} alt="map icon" className="map-icon" /> */}
                                <img src={vertical_line} alt="vertical line" className="vertical-line" />
                                <img src={filtericon} alt="filter icon" className="filter-icon" onClick={() => setFilterpopup(true)} />
                            </div>
                        </div>
                    </div>

                    <div className="category-title catgeory-list-page">
                        {categoryName && <h6>
                            <span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                Experience /
                            </span> {categoryName}</h6>}
                        {/* <p>{getDisplayCategoryList.length} offers</p> */}
                    </div>


                    <div className="offers-grid-container category-list-page">
                        {isCategoryListLoading ? (
                            // Shimmer loading skeleton
                            Array.from({ length: 6 }).map((_, index) => (
                                <div key={`shimmer-${index}`} className="offer-card-grid shimmer-card">
                                    <div className="offer-img-wrapper-grid shimmer-image"></div>
                                    <div className="offer-details-grid">
                                        <div className="shimmer-line shimmer-location"></div>
                                        <div className="shimmer-line shimmer-title"></div>
                                        <div className="shimmer-line shimmer-subtitle"></div>
                                        <div className="shimmer-line shimmer-price"></div>
                                    </div>
                                </div>
                            ))
                        ) : getDisplayCategoryList.length > 0 ? (
                            getDisplayCategoryList.map((item, index) => {
                                if (!item) return null;

                                let discountText;

                                switch (item.discount_type_id) {
                                    case 8:
                                    case 4:
                                        discountText = <span className="offer-tag">{item.discount_type || "Offer"}</span>;
                                        break;

                                    case 7:
                                        discountText = (
                                            <span className="offer-tag">
                                                {item.discount_value ? `${item.discount_value}% OFF` : (item.discount_type || "Offer")}
                                            </span>
                                        );
                                        break;

                                    case 5:
                                        discountText = (
                                            <span className="offer-tag">
                                                Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                                            </span>
                                        );
                                        break;

                                    case 1:
                                        discountText =
                                            item.discount_value && item.discount_price && item.coupon_price ? (
                                                <>
                                                    <span className="old-price">AED {item.coupon_price}</span>
                                                    <span className="new-price">AED {item.discount_price}</span>
                                                    <span className="separator">|</span>
                                                    <span className="discount">{item.discount_value}% OFF</span>
                                                </>
                                            ) : (
                                                <span className="offer-tag">AED {item.coupon_price || "N/A"}</span>
                                            );
                                        break;

                                    case 10:
                                        discountText = (
                                            <span className="discount_type_from">
                                                From <span className="discount_coupon_price">AED {item.coupon_price || "N/A"}</span>
                                            </span>
                                        );
                                        break;

                                    default:
                                        discountText =
                                            item.discount_type === "Total" ? (
                                                <span className="offer-tag">{item.discount_value || 0}% OFF</span>
                                            ) : (
                                                <span className="offer-tag">{item.discount_type || "Offer"}</span>
                                            );
                                }

                                // Safety check for category
                                const categoryId = item.category && Array.isArray(item.category) && item.category.length > 0
                                    ? item.category[0]?.category
                                    : null;

                                if (!categoryId || !item.coupon_id) return null;

                                return (
                                    <Link
                                        to={`/offers/${item.coupon_id}/${categoryId}`}
                                        className="remove-underline"
                                        key={`${item.coupon_id}-${index}`}
                                    >
                                        <div className="offer-card-grid">
                                            <div className="offer-img-wrapper-grid categorylistpage">
                                                <img
                                                    src={item.coupon_image || ""}
                                                    alt={item.coupon_title || "Offer"}
                                                    loading="lazy"
                                                />
                                            </div>

                                            <div className="offer-details-grid">
                                                <p className="offer-location">
                                                    <span>
                                                        <img src={businessicon} alt="logo" className="bussinessicon" />
                                                    </span>
                                                    <span>{item.user_name || "N/A"}</span>
                                                </p>

                                                <h4>{item.coupon_title || "Untitled Offer"}</h4>

                                                <p className="limited-deals-distance">
                                                    {item.distance ? Math.round(item.distance) : 0} km | {item.location || "N/A"}
                                                </p>

                                                <div className="offer-prices">{discountText}</div>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })
                        ) : (
                            <div className="nodata-message-categorylist">
                                <img src={nodata} alt="no data" className="no-data-img" />
                                <p className="no-data-p1">No offers found</p>
                                <p className="no-data-p2">Come back later to explore</p>
                            </div>
                        )}
                    </div>

                </main>


                {/* Country pop up */}
                {countrypopup && (
                    <>
                        {/* Overlay */}
                        <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>

                        {/* Centered Popup */}
                        <div className="custom-popup">
                            <div className="custom-popup-header">
                                <h4>Choose Your Location</h4>
                                <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                            </div>

                            {/* States List */}
                            <div className="custom-popup-body">
                                <div className="state-grid">
                                    {states.filter((state) => Number(state.country_id) === 1)
                                        .map((state, index, arr) => {
                                            const isDisabled = index >= arr.length - 4; // last 4 items

                                            return (
                                                <div
                                                    key={state.id}
                                                    className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                    onClick={() => !isDisabled && handleStateChange(state)}
                                                >
                                                    <img
                                                        src={index < 2 ? flagicon : countryicons[index - 2]}
                                                        alt="flag"
                                                        className="flagicon-popup"
                                                    />
                                                    <p>{state.name}</p>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </>
                )
                }
                {/* Discover category Popup Drawer */}
                {isPopupOpen && (
                    <>
                        <div className="overlay" onClick={() => setIsPopupOpen(false)}></div>
                        <div className="popup-drawer" >
                            <div className="popup-header">
                                <h4>Categories</h4>
                                <img src={xmark} alt="xmark" className="close-popup" onClick={() => setIsPopupOpen(false)} />
                            </div>
                            {/* You can add your list content here later */}
                            {Array.isArray(categories) && categories.length > 0 ? (
                                categories.map((item, index) => {
                                    const handleCategorySelect = () => {
                                        setSelectedCategory(item.id);
                                        setIsPopupOpen(false);
                                        // Scroll to the selected category in carousel
                                        if (sliderRef.current && sliderRef.current.slickGoTo) {
                                            setTimeout(() => {
                                                sliderRef.current.slickGoTo(index);
                                            }, 100);
                                        }
                                    };
                                    return (
                                        <div className="category-list" onClick={handleCategorySelect} key={index}>
                                            <div className="category-content">
                                                <div className="category-list-img">
                                                    <img
                                                        src={item.image}
                                                        alt={item.category_name}
                                                        className={item.id === Number(selectedCategory) ? "selected" : ""}
                                                    />                                                </div>
                                                <h6>{item.category_name}</h6>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                                    No categories available
                                </div>
                            )}
                        </div>
                    </>
                )
                }

                {filtepopup && (
                    <>
                        <div className="overlay" onClick={() => setFilterpopup(false)}></div>
                        <div className="popup-drawer">
                            <div className="popup-header">
                                <h4></h4>
                                <img src={xmark} alt="xmark" className="close-popup" onClick={() => setFilterpopup(false)} />
                            </div>

                            <div className="filter-list">

                                {/* Subcategories */}
                                <div className="filter-section">
                                    <div className="filter-header" onClick={toggleSubcategories}>
                                        <h6 className="filter-title">Subcategories</h6>
                                        <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${showSubcategories ? "rotate" : ""}`} />
                                    </div>
                                    {showSubcategories && (
                                        <div className="filter-checkbox-list">
                                            {Array.isArray(subcategories) && subcategories.length > 0 ? (
                                                subcategories.map((sub) => (
                                                    <label key={sub.id} className="filter-checkbox-item">
                                                        <input
                                                            type="checkbox"
                                                            value={sub.id}
                                                            checked={selectedSubcategories.includes(Number(sub.id))}
                                                            onChange={(e) => handleSubcategoryChange(e, sub.id)}
                                                        />
                                                        {sub.category_name}
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '10px', color: '#999' }}>No subcategories available</div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Offer type */}
                                <div className="filter-section">
                                    <div className="filter-header" onClick={toggleOfffertype}>
                                        <h6 className="filter-title">Offer Type</h6>
                                        <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${openoffertype ? "rotate" : ""}`} />
                                    </div>
                                    {openoffertype && (
                                        <div className="filter-checkbox-list">
                                            {offertype && Array.isArray(offertype.discounttypeData) && offertype.discounttypeData.length > 0 ? (
                                                offertype.discounttypeData.map((off) => (
                                                    <label key={off.id} className="filter-checkbox-item">
                                                        <input
                                                            type="checkbox"
                                                            value={off.id}
                                                            checked={selectedOfferTypes.includes(Number(off.id))}
                                                            onChange={(e) => handleOfferTypeChange(e, off.id)}
                                                        />
                                                        {off.discount_type}
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '10px', color: '#999' }}>No offer types available</div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Attributes */}
                                {Array.isArray(getattributes) && getattributes.length > 0 ? (
                                    getattributes.map((item) => (
                                        <div className="filter-section" key={item.id}>
                                            <div className="filter-header" onClick={() => toggleAttributeFields(item.id)}>
                                                <h6 className="filter-title">{item.attribute_name}</h6>
                                                <img
                                                    src={downarrowicon}
                                                    alt="down arrow"
                                                    className={`sub-down-arrow-icon ${openAttributeId === item.id ? "rotate" : ""}`}
                                                />
                                            </div>

                                            {openAttributeId === item.id && Array.isArray(item.attribute_fields) && item.attribute_fields.length > 0 && (
                                                <div className="filter-checkbox-list">
                                                    {item.attribute_fields.map((field) => (
                                                        <label key={field.id} className="filter-checkbox-item">
                                                            <input
                                                                type="checkbox"
                                                                value={field.id}
                                                                checked={selectedAttributes.includes(field.id)}
                                                                onChange={(e) => handleAttributeChange(e, field.id)}
                                                            />
                                                            {field.attributes_value}
                                                        </label>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))
                                ) : null}

                                <div className="filter-buttons">
                                    <button className="clear-btn" onClick={clearAllFilters}>Clear All</button>
                                    <button className="show-btn" onClick={handleShowResult}>Show Result</button>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}



export default CategoryList